import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";

const SELECTOR_SUBMIT_BUTTON = "button[type=submit]";
const SELECTOR_INPUTS_READONLY = "input[readonly]";
const SELECTOR_INPUT_BUTTON = "a.input-button";
const SELECTOR_DATEPICKER_STARTDATE = ".flatpickr.start-date";
const SELECTOR_DATEPICKER_ENDDATE = ".flatpickr.end-date";
const SELECTOR_STARTDATE_INPUT_FIELD = 'input[name="startdate"]';
const SELECTOR_ENDDATE_INPUT_FIELD = 'input[name="enddate"]';

export default class DateFilterDom extends DomElementsBase {
	constructor($module) {
		const selectors = [
			SELECTOR_SUBMIT_BUTTON,
			SELECTOR_INPUTS_READONLY,
			SELECTOR_INPUT_BUTTON,
			SELECTOR_DATEPICKER_STARTDATE,
			SELECTOR_DATEPICKER_ENDDATE,
			SELECTOR_ENDDATE_INPUT_FIELD,
			SELECTOR_STARTDATE_INPUT_FIELD,
		];

		super($module, selectors);

		this.$submitButton = this.getElements(SELECTOR_SUBMIT_BUTTON);
		this.startDatePicker = this.getElement(SELECTOR_DATEPICKER_STARTDATE);
		this.endDatePicker = this.getElement(SELECTOR_DATEPICKER_ENDDATE);
	}

	getSubmitButton() {
		return this.$submitButton;
	}

	getStartDatePickerElement() {
		return this.startDatePicker;
	}

	getEndDatePickerElement() {
		return this.endDatePicker;
	}

	getDateInputElements() {
		return this.getElements(SELECTOR_INPUTS_READONLY);
	}

	getDateInputButtonElements() {
		return this.getElements(SELECTOR_INPUT_BUTTON);
	}

	getEndDateElement() {
		return this.getElement(SELECTOR_ENDDATE_INPUT_FIELD);
	}

	getStartDateElement() {
		return this.getElement(SELECTOR_STARTDATE_INPUT_FIELD);
	}
}
